import React, { useState } from 'react';
import { IClientInfo } from '../../lib/types';
import { resolveAssetUrl } from '../../lib/ultra-meet-config';
import { phoneToTelHref } from '../../lib/theme-utils';
import { AppBranding } from '../shared/AppBranding';
import styles from '../../styles/AuthenticatedHome.module.css';

interface DefaultHomeContentProps {
  themeConfig: IClientInfo;
  translations: any;
}

export const DefaultHomeContent: React.FC<DefaultHomeContentProps> = ({
  themeConfig,
  translations
}) => {
  const [showSupportDialog, setShowSupportDialog] = useState(false);

  const handleSupportClick = () => {
    setShowSupportDialog(true);
  };

  const handleWriteClick = () => {
    window.open(themeConfig.supportLink, '_blank');
    setShowSupportDialog(false);
  };

  const handleCancelClick = () => {
    setShowSupportDialog(false);
  };

  return (
    <div className={styles.content}>
      <div className={styles.centerContent}>
        <div className={styles.logo}>
          <AppBranding
            themeConfig={themeConfig}
            translations={translations}
            height={80}
          />
        </div>

        {!!themeConfig.supportPhones?.length && (
          <div className={styles.supportContainer}>
            <div className={styles.supportTitle}>{translations.home.supportTitle}:</div>
            {themeConfig.supportPhones.map((phone) => (
              <a key={phone} href={phoneToTelHref(phone)} className={styles.supportPhone}>{phone}</a>
            ))}
          </div>
        )}
      </div>

      {themeConfig.supportLink && (
        <button className={styles.supportButton} onClick={handleSupportClick}>
          <img src={resolveAssetUrl('/images/ic_support.svg')} alt="Support" />
        </button>
      )}

      {showSupportDialog && (
        <div className={styles.supportDialogOverlay} onClick={handleCancelClick}>
          <div className={styles.supportDialogContent} onClick={(e) => e.stopPropagation()}>
            <h2 className={styles.supportDialogTitle}>{translations.home.supportDialog.title}</h2>
            <p className={styles.supportDialogText}>{translations.home.supportDialog.text}</p>
            <div className={styles.supportDialogButtons}>
              <button className={styles.supportDialogCancelButton} onClick={handleCancelClick}>
                {translations.home.supportDialog.cancelButton}
              </button>
              <button className={styles.supportDialogWriteButton} onClick={handleWriteClick}>
                {translations.home.supportDialog.writeButton}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
